import { render } from "./AddSaleView.vue?vue&type=template&id=61bbcd7d"
import script from "./AddSaleView.vue?vue&type=script&lang=js"
export * from "./AddSaleView.vue?vue&type=script&lang=js"

import "./AddSaleView.vue?vue&type=style&index=0&id=61bbcd7d&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__